import React from "react";
import {
  CatalogPage,
  printingCatalogConfig,
} from "../features/design-catalog";
import SEO from "../components/SEO";

const Printing = () => (
  <>
    <SEO
      title="Printing"
      description="Comprehensive printing services to boost your brand visibility. Ground activations, awareness campaigns, local promotions, and strategic marketing solutions at Indorinama."
      keywords="marketing services, brand promotion, advertising, promotional campaigns, marketing agency, digital promotion, India marketing, advertising agency"
      url="https://indorinama.com/printing"
      type="website"
    />
    <CatalogPage config={printingCatalogConfig} />
  </>
);

export default Printing;
